import { create } from 'zustand';

export const useNotificationsStore = create((set, get) => ({
  // State
  notifications: [],
  unreadCount: 0,
  whatsappUnreadCount: 0,
  isLoading: false,
  lastFetched: null,

  // Transform GetList API items into the internal notification shape
  transformNotificationData: (apiData) => {
    if (!apiData || !Array.isArray(apiData)) return [];

    return apiData.map((item) => ({
      id: item.id,
      destinatarioId: item.destinatario_id,
      tipo: item.tipo || 'info',
      titulo: item.titulo,
      mensaje: item.mensaje,
      source: item.source,
      prioridad: item.prioridad,
      accionRuta: item.accion_ruta,
      accionTarget: item.accion_target,
      fechaCreacion: item.fecha_creacion,
      readAt: item.read_at,
      dismissedAt: item.dismissed_at
    }));
  },

  // Poll the unread count silently. Called by useNotificationsPoller.
  // Stores the number of unread (read_at IS NULL AND dismissed_at IS NULL) notifications.
  fetchUnreadCount: (apiFetcher) => {
    apiFetcher({
      type: 'POST',
      url: '?section=notificaciones&action=GetUnreadCount',
      data: new FormData(),
      showSuccessNotification: false,
      showErrorNotification: false,
      onSuccess: (payload) => {
        if (typeof payload.total === 'number') {
          set({ unreadCount: payload.total });
        }
      },
      onError: () => {
        console.warn('[NotificationsStore] GetUnreadCount fetch failed');
      }
    });
  },

  // Fetch the list via GetList (side effect: marks the user's notifications as read).
  // Called when the popup opens. Resets the local unread count to 0 afterwards.
  fetchNotifications: (fetchAPI) => {
    set({ isLoading: true });

    return new Promise((resolve) => {
      fetchAPI({
        section: 'notificaciones',
        action: 'GetList',
        params: {},
        loadingMessage: 'Cargando notificaciones...',
        showErrorNotificationModal: true,
        OnLoaded: (success, payload) => {
          if (success && payload && Array.isArray(payload.notificaciones)) {
            const transformed = get().transformNotificationData(payload.notificaciones);
            set({
              notifications: transformed,
              unreadCount: 0,
              isLoading: false,
              lastFetched: new Date().toISOString()
            });
            resolve(true);
          } else {
            set({ notifications: [], isLoading: false });
            resolve(false);
          }
        }
      });
    });
  },

  // Dismiss a single notification via Dismiss (POST notificacion_id = parent id).
  // Updates local state optimistically.
  dismiss: (notificacionId, fetchAPI) => {
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== notificacionId)
    }));

    return new Promise((resolve) => {
      fetchAPI({
        section: 'notificaciones',
        action: 'Dismiss',
        params: { notificacion_id: notificacionId },
        showErrorNotificationModal: true,
        OnLoaded: (success) => {
          resolve(success);
        }
      });
    });
  },

  // Dismiss every notification via DismissAll. Updates local state optimistically.
  dismissAll: (fetchAPI) => {
    set({ notifications: [], unreadCount: 0 });

    return new Promise((resolve) => {
      fetchAPI({
        section: 'notificaciones',
        action: 'DismissAll',
        params: {},
        showErrorNotificationModal: true,
        OnLoaded: (success) => {
          resolve(success);
        }
      });
    });
  },

  // Reset the entire store (used on logout)
  resetStore: () => {
    set({
      notifications: [],
      unreadCount: 0,
      whatsappUnreadCount: 0,
      isLoading: false,
      lastFetched: null
    });
  }
}));

export default useNotificationsStore;
